import { FunctionComponent, useEffect, useState } from 'react';
// import { useTheme } from '@mui/material/styles';
import { useAtom } from 'jotai';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next'

import { fetch_all, fetch_one } from '../../lib/server_helper';
// import { checkAllowed } from '../../lib/permission';

import {
  CircularProgress,
} from '@mui/material';
import { GridColDef } from '@mui/x-data-grid-pro';

import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

import { AlertSomethingWentWrong } from '../../components/alerts/SomethingWentWrong';

import {
  DataGrid,
  Page,
  SearchBox,
  StyledIconButton,
  Typography
} from '../../components/interface';

import { ReportVersion } from '../../models/ReportVersion';
import { loginAtom } from '../../lib/auth';

type Props = {};

export const AdminReportVersions: FunctionComponent<Props> = () => {
  // const theme = useTheme();
  const navigate = useNavigate();
  const {t, i18n} = useTranslation(['translations']);

  const [login, setLogin] = useAtom(loginAtom);

  const params = useParams();
  const reportId: string | undefined = params.report_id;

  const [objects, setObjects] = useState<ReportVersion[]>([]);
  const [objectsCount, setObjectsCount] = useState<number>(0);
  const [loader, setLoader] = useState<boolean>(true);
  const [removeLoader, setRemoveLoader] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [order, setOrder] = useState<string>("id DESC");
  const [serverErrorSnackOpen, setServerErrorSnackOpen] = useState<boolean>(false);

  // Settings


  useEffect(() => {
    if (!!reportId) onSearch('');
  }, [page, order]);

  const onRemove = (id: number) => {
    // if (checkAllowed(login, null, projectId?.toString() || '0', "ProjectReports", 'd', true)) {
      setRemoveLoader(true);
      fetch_one<ReportVersion>('/nl/v3/objects/remove', {
        object: 'report_version',
        ob: {
          id: id
        }
      }, (obs, complete_data) => {
        onSearch('');
        setRemoveLoader(false);
      }, (z) => {

      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    // }
  };

  const onSearch = (s: string) => {
    // if (checkAllowed(login, null, projectId?.toString() || '0', "ProjectReports", 'r', true)) {
      // console.log(filters);
      setLoader(true);
      fetch_all<ReportVersion>('/nl/v3/objects/fetch_all', {
        object: 'report_version',
        fields: ['id', 'created_at', 'updated_at', 'name', 'get_item_xls', 'report|id/name/get_item_xls', 'user|id/full_name'],
        per_page: 20,
        page: page,
        order: order,
        filter: {
          search: s,
          advanced: {
            report_id: reportId,
            fallback: s
          }
        }
      }, (obs, complete_data) => {
        setObjects(obs);

        let count:number = 0;
        if (typeof(complete_data?.data) === 'object' && 'count' in complete_data?.data) count = complete_data?.data?.count;
        setObjectsCount(count);

        setLoader(false);
      }, (z) => {
        setServerErrorSnackOpen(true);
      }, (!!login?.auth_token ? {auth_token: login?.auth_token, email: login?.email} : undefined));
    // } else {
    //   setLoader(false);
    // }
  };

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID', width: 100, sortable: true },
    { field: 'name', headerName: 'Version Name', width: 250, renderCell: params => <>
      <Typography sx={{
        fontSize: '0.9rem',
        cursor: 'pointer',
        textDecoration: 'underline'
      }} onClick={() => {
        window.open(`/report_version/${params.row.id}`, "_BLANk");
      }}>{params.row.name}</Typography>
    </> },
    { field: 'report_versions_first_user_full_name', headerName: 'Version by', width: 250, sortable: false, renderCell: params => <>
      <Typography sx={{
        fontSize: '0.9rem'
      }}>{params.row.user_full_name}</Typography>
    </> },
    ...(!(!login?.is_admin && !!login?.is_organiser) ? [{ field: 'raw_xls', headerName: 'XLSX', width: 100, sortable: false, renderCell: (params:any) => <>
      {!!params.row.get_item_xls && <CloudDownloadIcon onClick={() => {
        window.open(params.row.get_item_xls, "_BLANK");
      }} sx={{
        cursor: 'pointer',
      }} />}
    </> }] : []),
  ];

  return (
    <Page sx={{}} title={t("objects.report_versions.title", "Rapportversies")}>
      {/* <SearchBox
        simple={true}
        onSearch={(s) => {
          setPage(0);
          onSearch(s);
        }}
      /> */}
      <DataGrid
        action_count={1}
        actions={(params) => {
          return (<>
            {!!removeLoader && <CircularProgress />}
            {/* {checkAllowed(login, null, projectId?.toString() || '0', "ProjectReports", 'd', true) && !removeLoader && <StyledIconButton title="Destroy" destroyBtn color="primary" onClick={(e) => {
              onRemove(params.row.id);
            }}>
              <DeleteForeverIcon />
            </StyledIconButton>} */}
            {!!login?.is_admin && !removeLoader && <StyledIconButton title="Destroy" destroyBtn color="primary" onClick={(e) => {
              onRemove(params.row.id);
            }}>
              <DeleteForeverIcon />
            </StyledIconButton>}
          </>);
        }}
        getRowClassName={(params) => `datagrid-row-enabled-${params.row.enabled}`}
        objectCount={objectsCount}
        objects={(objects || []).map(u => ({
          ...u
        }))}
        columns={columns}
        loader={loader}
        onSortModelChange={(a, b) => {
          let a_0_field:string = a[0].field;
          setOrder([a_0_field, a[0].sort].join(' '));
        }}
        page={page}
        setPage={(p) => {setPage(p);}}
      />

      {!!serverErrorSnackOpen && <AlertSomethingWentWrong open={serverErrorSnackOpen} setOpen={(b) => {setServerErrorSnackOpen(b);}} />}
    </Page>
  );
}
